import { API_URL } from "../_config/config.const";
import { getBody } from "../_helpers/body.helper";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";
import { getFormAccessToken } from "../_helpers/formAccessToken.helper";

const API_NAME = "quoteProviderPrice";

export const quoteProviderPriceService = {
    updateOnApply,
    updateOnApplyForMortgage
};

function updateOnApply(query: any) {
    const requestOptions = { method: 'PUT', headers: getHeader(), body: getBody(query) };
    const token = getFormAccessToken(query?.formId) || getFormAccessToken();
    return fetch(`${API_URL}/${API_NAME}/updateOnApply/?token=${encodeURIComponent(token)}`, requestOptions).then(handleResponse);
}
function updateOnApplyForMortgage(id: number, quoteId: number) {
    const requestOptions = { method: 'PUT', headers: getHeader() };
    const token = getFormAccessToken();
    return fetch(`${API_URL}/${API_NAME}/updateOnApplyForMortgage/?id=${id}&quoteId=${quoteId}&token=${encodeURIComponent(token)}`, requestOptions).then(handleResponse);
}

